/** CanvasModulate registration: the parser. */
import { nodeRegistry } from '../../../core/NodeRegistry';
import { parseCanvasModulate } from './parser';
const canvasModulateRegistration = {
    typeName: 'CanvasModulate',
    parser: parseCanvasModulate,
};
nodeRegistry.register(canvasModulateRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map